import { render } from "./PropertieUpdate.vue?vue&type=template&id=561ce034"
import script from "./PropertieUpdate.vue?vue&type=script&lang=js"
export * from "./PropertieUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__